export const formatHumanDuration = (totalSec: number): string => {
  if (totalSec <= 0) return '0m';
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
};

export const formatPlannedCompact = (minutes: number): string => {
  const safeMinutes = Math.max(0, Math.round(minutes));
  if (safeMinutes < 60) return `${safeMinutes}m`;
  const hours = safeMinutes / 60;
  const rounded = Math.round(hours * 100) / 100;
  const isWhole = Number.isInteger(rounded);
  const hoursText = isWhole ? String(Math.round(rounded)) : String(rounded);
  return `${hoursText} ${rounded === 1 ? 'hr' : 'hrs'}`;
};
